import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TagComponent } from '@pedix-workspace/angular-ui-alert';

@Component({
  selector: 'pxw-cart-product-group-shell',
  templateUrl: './cart-product-group-shell.component.html',
  styleUrls: ['./cart-product-group-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagComponent],
  host: {
    '[class.product-group-shell--readonly]': 'readOnly()',
  },
})
export class CartProductGroupShellComponent {
  readonly readOnly = input(false);
  readonly isCategoryAvailable = input.required<boolean>();
  readonly promoTagLabels = input.required<string[]>();
  readonly formattedSavings = input<string | undefined>(undefined);
  readonly subtotalLabel = input.required<string>();
  readonly formattedSubtotal = input<string | undefined>(undefined);
}
